export const googleApiLibraries = ['maps', 'geometry', 'places'];
